import React from 'react';

import './CheckmarkList.module.css';

const CheckmarkList = ({ items, width }) => {
  return (
    <div styleName="list-container">
      {items.map(item => {
        return <p styleName={`item width-${width}`}>{item}</p>;
      })}
    </div>
  );
};

export default CheckmarkList;
